<template>
    <section class="blog" id="blog">
        <div class="holder" v-if="holder"></div>

        <div v-else>
            <BlogIntro/>
            <BlogNewsletter/>

            <div class="container filter-content">
                <div class="results">Mostrando 1-16 de 120 acabamentos</div>
            </div>

            <BlogNewsCarousel :blogPage="true" :no-border="false"/>

            <BlogCarousel v-for="category in cat"
                          :key="category.id"
                          :category="category"
                          :categoryFlag="category.color"
                          :categoryTitle="category.name"/>
        </div>
    </section>
</template>

<script>
    import BlogIntro from "../components/Blog/BlogIntro/BlogIntro";
    import BlogNewsletter from "../components/Blog/BlogNewsletter/BlogNewsletter";
    import BlogCarousel from "../components/Blog/BlogCarousel/BlogCarousel";
    import BlogNewsCarousel from "../components/Shared/BlogNewsCarousel";

    export default {
        name: "Blog",
        components: {
            BlogIntro,
            BlogNewsletter,
            BlogCarousel,
            BlogNewsCarousel
        },
        data() {
            return {
                cat: [],
                holder: true,
            }
        },
        methods: {
            fetchCategories() {
                axios.get('/categoria_blog')
                    .then(r => {
                        this.cat = r.data;
                        this.holder = false;
                    })
            }
        },
        mounted() {
            this.fetchCategories()
            document.title = 'Fibrillare - Blog';
            window.scrollTo({
                top: 0,
                behavior: 'auto',
            })
        }
    }
</script>

<style lang="scss" scoped>
    #blog {
        margin-top: 83px;
    }

    .filter-content {
        display: flex;
        justify-content: flex-end;
        margin-top: 50px;
    }

    .filter {
        padding: 10px 100px 10px 15px;
        border: 1px solid #babfc2;
        border-radius: 4px;
        font-family: "Open Sans";
        font-size: 0.875rem;
        color: #2b2b2b;
    }

    .results {
        font-family: "Open Sans";
        font-size: 0.875rem;
        color: #2b2b2b;
    }

    @media only screen and(max-width: 1200px) {
        #blog {
            margin-top: 79px;
        }
    }

    @media only screen and(max-width: 767px) {
        .filter-content {
            flex-direction: column;
        }

        .filter {
            margin-bottom: 20px;
        }

        .results {
            text-align: right;
        }
    }

</style>